<template>
  <header :class="['header', { scrolled }]">
    <div class="wrap bar">
      <NuxtLink to="/" class="brand">
        <NuxtImg v-if="props.adminInfo?.logo" format="webp" loading="lazy" class="logo-img" sizes="50px"
          :src="`${$config.public.imageURL}${props.adminInfo.logo}`" alt="logo" />
        <span>{{ props.adminInfo?.brand_name }}</span>
      </NuxtLink>
      <nav class="nav">
        <NuxtLink v-if="!isLogin" class="pill" to="/new-login">會員登入</NuxtLink>
        <NuxtLink v-if="!isLogin" class="pill primary" to="/new-register">註冊</NuxtLink>
        <div v-if="isLogin" class="pill primary cursor-pointer" @click="handleLogout">登出</div>
      </nav>
    </div>
  </header>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useUserStore } from '@/stores/user'

const userStore = useUserStore()
const isLogin = computed(() => userStore.getToken)
const { $config } = useNuxtApp()

interface AdminInfo {
  logo?: string
  brand_name?: string
  [k: string]: any
}

const props = defineProps<{
  adminInfo: AdminInfo
}>()

const scrolled = ref(false)

function onScroll() {
  scrolled.value = window.scrollY > 10
}

function handleLogout() {
  userStore.logout()
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
})
onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<style scoped lang="scss">
.wrap {
  max-width: var(--max, 1200px);
  margin-inline: auto;
  padding-inline: clamp(16px, 3vw, 28px);
}

.header {
  position: sticky;
  top: 0;
  z-index: 40;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border-light, #f0f0f0);
  transition: all 0.3s ease;
}

.header.scrolled {
  box-shadow: var(--shadow, 0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04));
}

.bar {
  height: 80px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 700;
  color: var(--text, #2c2c2c);
  font-size: 1.1rem;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.brand:hover {
  opacity: 0.8;
}

.logo-img {
  height: 50px !important;
  width: auto !important;
  max-width: 200px;
  object-fit: contain;
}

.nav {
  margin-left: auto;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0.6rem 1.2rem;
  border-radius: var(--radius, 8px);
  border: 1px solid var(--border, #e5e5e5);
  background: var(--bg, #ffffff);
  font-weight: 600;
  color: var(--text, #2c2c2c);
  transition: all 0.3s ease;
}

.pill:hover {
  border-color: var(--primary, #c9a876);
  transform: translateY(-1px);
  box-shadow: var(--shadow, 0 4px 20px rgba(0, 0, 0, 0.08));
}

.pill.primary {
  border-color: transparent;
  background: var(--primary, #c9a876);
  color: #fff;
  box-shadow: var(--shadow, 0 4px 20px rgba(0, 0, 0, 0.08));
}

.pill.primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-hover, 0 8px 30px rgba(0, 0, 0, 0.12));
}
</style>
